import { type History } from 'history';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import ui from './middleware/screenResize';
import personalDetailsReducer from '../tabs/PersonalDetails/ducks';
import notificationSettingsReducer from '../tabs/NotificationSettings/ducks';
import financingTermsReducer from '../tabs/FinancingTerms/ducks';
import referralsReducer from '../tabs/Referrals/ducks';
import sharedReducer from '../shared/ducks';

export default (history: History) =>
  combineReducers({
    router: connectRouter(history),
    ui,
    personalDetails: personalDetailsReducer,
    notificationSettings: notificationSettingsReducer,
    financingTerms: financingTermsReducer,
    referrals: referralsReducer,
    shared: sharedReducer
  });
